import React from "react";


import { TableCell } from "@/components/flowbite/table/table-cell";
import { TableHead } from "@/components/flowbite/table/table-head";
import { TableRow } from "@/components/flowbite/table/table-row";
import Typography from "@/components/flowbite/typography/typography";
import { cn } from "@/shared/helpers/cn.helper";

import { BASIC_INFO_ROW_CELL_BORDER_CLASS } from "./basic-information-table-row-border";

interface BasicInformationTableTextRowProps {
  head: string;
  value: string;
}

export const BasicInformationTableTextRow: React.FC<
  BasicInformationTableTextRowProps
> = ({ head, value }) => {

  return (
    <TableRow>
      <TableHead
        className={cn(
          "m-0 h-[50px] min-h-[50px] w-[100px] min-w-[100px] max-w-[100px] whitespace-normal text-wrap break-words p-0 pr-3",
          BASIC_INFO_ROW_CELL_BORDER_CLASS,
        )}
      >
        <Typography.TableTitleXS colorShade={300}>
          {head}
        </Typography.TableTitleXS>
      </TableHead>
      <TableCell
        className={cn(
          "m-0 h-[50px] min-h-[50px] whitespace-normal text-wrap break-words p-0",
          BASIC_INFO_ROW_CELL_BORDER_CLASS,
        )}
      >
        <Typography.BodyMRegular colorShade={400}>
          {value}
        </Typography.BodyMRegular>
      </TableCell>
    </TableRow>
  );
};